







































import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'

export default Vue.extend({
  name: 'confirm-ticket',
  props: {
    lang: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    countryName: {
      type: String,
      default: ''
    },
    outgoingMessage: {
      type: String,
      default: ''
    },
    missionMessage: {
      type: String,
      default: ''
    },
    confirmPublishing: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    }
  }
})
